export default __webpack_public_path__ + "static/media/wife-and-cat-md-1x.11622b7d.jpg";